import { AnalyticsEvent } from '../../analytics.event';

export class AppLaunchEvent extends AnalyticsEvent {
    constructor() {
        super('app_launch');
    }
}
